import React, { useEffect, useState } from 'react';
import { Spin, Table } from 'antd';
import qs from 'qs';
import PaginationComponent from '../pagination/PaginationComponent';
import { useTranslation } from 'react-i18next';
const TableFetchData = ({
  x,
  y,
  size,
  tableParams,
  setTableParams,
  data,
  setData,
  loading,
  setLoading,
  columns,
  onRow,
  components,
  rowClassName,
  ...restProps
}) => {
  const { t } = useTranslation();

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      ...tableParams,
      // pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      // setData([]);
    }
  };

  return (
    <>
    <Spin spinning={loading ? loading : false}>
      <Table
        columns={columns}
        size={size ? size : 'middle'}
        dataSource={data}
        pagination={false}
        onChange={handleTableChange}
        onRow={onRow}
        components={components}
        rowClassName={rowClassName}
        {...restProps}
        locale={{
          emptyText: t('common.noData'),
          triggerAsc: t('common.clickToSortAscending'),
          triggerDesc: t('common.clickToSortDescending'),
          cancelSort: t('common.clickToCancelSorting'),
        }}
        scroll={{ x: x ? x : 1000, y: y ? y : null }}
      />
      <div className='w-100 mt-3'>
        <PaginationComponent
          onChange={(page, pageSize) => {
            setTableParams({
              ...tableParams,
              pagination: {
                ...tableParams.pagination,
                current: page,
                pageSize: pageSize,
              },
            });
          }}
          tableParams={tableParams} setTableParams={setTableParams}
          total={tableParams && tableParams.pagination && tableParams.pagination.total ? tableParams.pagination.total : 0}
        />
      </div>
    </Spin>
    </>
  );
};
export default TableFetchData;